import React from 'react';
import { Alert, Button, Container } from 'react-bootstrap';

const isDev = process.env.NODE_ENV !== 'production';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null, showDetails: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Unhandled error caught by ErrorBoundary:', error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container className="p-4">
          <Alert variant="danger">
            <Alert.Heading>Something went wrong</Alert.Heading>
            <p>This page ran into an unexpected error. You can try reloading, or go back to the previous page.</p>
            <Button variant="outline-danger" className="me-2" onClick={() => window.location.reload()}>
              Reload
            </Button>
            <Button variant="outline-secondary" onClick={() => window.history.back()}>
              Go Back
            </Button>
            {isDev && (
              <div className="mt-3">
                <Button
                  variant="link"
                  className="p-0"
                  onClick={() => this.setState(prev => ({ showDetails: !prev.showDetails }))}
                >
                  {this.state.showDetails ? 'Hide' : 'Show'} error details (dev only)
                </Button>
                {this.state.showDetails && (
                  <pre className="mt-2 p-2 bg-light border small" style={{ whiteSpace: 'pre-wrap' }}>
                    {this.state.error && this.state.error.toString()}
                    {this.state.errorInfo && this.state.errorInfo.componentStack}
                  </pre>
                )}
              </div>
            )}
          </Alert>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
